<template>
  <accordion-panel
    :id="panelId"
    :collapsed.sync="collapsedProxy"
    @update:collapsed="onCollapsedChange"
  >
    <template #title>
      <s-icon
        v-if="alarmed"
        name="exclamation-triangle"
        class="text-red p-1 mr-1"
      />
      <label
        :class="alarmed ? 'text-red' : ''"
        class="mb-0"
      >
        {{ $t(`enums.engineering.chromatography.rules.${rule}`) }}
      </label>
    </template>
    <div
      v-if="showData"
      class="w-100 d-flex flex-wrap justify-content-center"
    >
      <result-card
        class="rule-panel__result-card"
        v-for="methodResult in resultsToShow"
        :key="methodResult.method"
        :rule="rule"
        :method="methodResult.method"
        :alarmed="methodResult.alarmed"
        :executed="methodResult.executed"
        v-model="methodResult.data"
      />
    </div>
    <s-empty-list
      v-else
      :loading="loading"
    />
  </accordion-panel>
</template>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.rule-panel
  &__result-card
    margin-top: .7rem
    margin-bottom: .7rem
    +media-max-sm
      width: 100%
    +media-min-md
      display: inline-flex
      margin-right: 1rem
      margin-left: 1rem
</style>

<script>
import LoadingMixin from '@/services/loadingMixin';
import AccordionPanel from '@/components/AccordionPanel';
import IndividualAnalysisService
  from '@/domain/services/installation/engineering/chromatography/individualAnalysis';
import ResultCard from './ResultCard';

export default {
  props: {
    rule: String,
    assetModuleId: String,
    sampleId: String,
    expanded: Boolean,
    alarmed: Boolean,
    showOnlyAlarmedMethods: Boolean,
  },
  components: {
    AccordionPanel,
    ResultCard,
  },
  mixins: [
    LoadingMixin,
  ],
  data: () => ({
    methodsResults: null,
  }),
  computed: {
    collapsedProxy: {
      get() {
        return !this.expanded;
      },
      set(value) {
        this.$emit('update:expanded', !value);
      },
    },
    panelId() {
      return `rule-panel-${this.rule}`;
    },
    showData() {
      return !this.loading && this.methodsResults && this.resultsToShow.length > 0;
    },
    resultsToShow() {
      if (this.showOnlyAlarmedMethods) {
        return this.methodsResults.filter(({ alarmed }) => alarmed);
      }

      return this.methodsResults;
    },
  },
  methods: {
    onCollapsedChange(collapsed) {
      if (!collapsed && this.methodsResults == null) {
        this.loadMethodsResults();
      }
    },
    async loadMethodsResults() {
      this.startLoading();
      try {
        this.methodsResults = await IndividualAnalysisService
          .getRuleResult(this.assetModuleId, this.sampleId, this.rule);
      } finally {
        this.endLoading();
      }
    },
  },
  created() {
    if (this.expanded) {
      this.loadMethodsResults();
    }
  },
};
</script>
